var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _c(
        "div",
        { staticClass: "contentDetails c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c("div", [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                },
              },
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _vm.orderMessage.status == 1 ||
                    _vm.orderMessage.status == 3 ||
                    _vm.orderMessage.status == 4 ||
                    _vm.orderMessage.status == 5 ||
                    _vm.orderMessage.status == 6
                      ? _c("img", {
                          staticStyle: { "margin-right": "8px" },
                          attrs: {
                            src: require("../../../assets/icon_wait.png"),
                          },
                        })
                      : _vm._e(),
                    _vm.orderMessage.status == 2
                      ? _c("img", {
                          staticStyle: { "margin-right": "8px" },
                          attrs: {
                            src: require("../../../assets/icon_guanbi.png"),
                          },
                        })
                      : _vm._e(),
                    _vm.orderMessage.status == 7
                      ? _c("img", {
                          staticStyle: { "margin-right": "8px" },
                          attrs: {
                            src: require("../../../assets/icon_quxiao.png"),
                          },
                        })
                      : _vm._e(),
                    _vm.orderMessage.status == 8
                      ? _c("img", {
                          staticStyle: { "margin-right": "8px" },
                          attrs: {
                            src: require("../../../assets/icon_wancheng.png"),
                          },
                        })
                      : _vm._e(),
                    _vm.orderMessage.status == 1
                      ? _c("span", { staticClass: "boldSize" }, [
                          _vm._v(" 待审核 "),
                        ])
                      : _vm._e(),
                    _vm.orderMessage.status == 2
                      ? _c("span", { staticClass: "boldSize" }, [
                          _vm._v("申请已驳回"),
                        ])
                      : _vm._e(),
                    _vm.orderMessage.status == 3
                      ? _c("span", { staticClass: "boldSize" }, [
                          _vm._v("申请已通过，待买家寄回商品"),
                        ])
                      : _vm._e(),
                    _vm.orderMessage.status == 4
                      ? _c("span", { staticClass: "boldSize" }, [
                          _vm._v("买家已寄回，待卖家签收"),
                        ])
                      : _vm._e(),
                    _vm.orderMessage.status == 6
                      ? _c("span", { staticClass: "boldSize" }, [
                          _vm._v("卖家已寄出换货商品，待买家签收"),
                        ])
                      : _vm._e(),
                    _vm.orderMessage.status == 5
                      ? _c("span", { staticClass: "boldSize" }, [
                          _vm._v(" 买家寄回商品已签收，待卖家换货寄出 "),
                        ])
                      : _vm._e(),
                    _vm.orderMessage.status == 7
                      ? _c("span", { staticClass: "boldSize" }, [
                          _vm._v(" 售后申请已取消 "),
                        ])
                      : _vm._e(),
                    _vm.orderMessage.status == 8 &&
                    _vm.orderMessage.afterType == 0
                      ? _c("span", { staticClass: "boldSize" }, [
                          _vm._v("已退款"),
                        ])
                      : _vm._e(),
                    _vm.orderMessage.status == 8 &&
                    _vm.orderMessage.afterType == 1
                      ? _c("span", { staticClass: "boldSize" }, [
                          _vm._v("售后完成，已成功退款"),
                        ])
                      : _vm._e(),
                    _vm.orderMessage.status == 8 &&
                    _vm.orderMessage.afterType == 2
                      ? _c("span", { staticClass: "boldSize" }, [
                          _vm._v("买家已签收"),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            ),
          ]),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "min-height": "120px",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { width: "14%", "margin-top": "20px" } },
                [
                  _vm.orderMessage.status == 1
                    ? _c(
                        "div",
                        { staticStyle: { width: "300px" } },
                        [
                          _c("div", { staticClass: "fontC" }, [
                            _vm._v("请及时审核！"),
                          ]),
                          _vm.orderMessage.afterType == 0
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-top": "10px" },
                                  attrs: {
                                    type: "primary",
                                    size: "small",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.isApply = true
                                    },
                                  },
                                },
                                [_vm._v("审核申请")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.orderMessage.status == 2
                    ? _c("div", { staticStyle: { width: "300px" } }, [
                        _c("div", { staticClass: "fontC" }, [
                          _vm._v("驳回理由"),
                        ]),
                        _c("div", { staticClass: "fontC" }, [
                          _vm._v(
                            " " + _vm._s(_vm.orderMessage.approveRemark) + " "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.orderMessage.status == 3
                    ? _c("div", { staticStyle: { width: "300px" } }, [
                        _c("div", { staticClass: "fontC" }, [
                          _vm._v("买家寄回中..."),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.orderMessage.status == 4
                    ? _c(
                        "div",
                        [
                          _c("div", { staticClass: "fontC" }, [
                            _vm._v("买家寄回中..."),
                          ]),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-wrap": "wrap",
                                width: "300px",
                              },
                            },
                            [
                              _vm.backInfo
                                ? _c(
                                    "div",
                                    { staticStyle: { color: "#4168e7" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.backInfo.logisticsCompanyLabel
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.backInfo
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "#4168e7",
                                        "margin-left": "10px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.backInfo.logisticsNumber) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-top": "10px" },
                              attrs: {
                                size: "small",
                                type: "primary",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.examine(1)
                                },
                              },
                            },
                            [_vm._v("查看物流")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.orderMessage.status == 6
                    ? _c(
                        "div",
                        { staticStyle: { width: "300px" } },
                        [
                          _c("div", { staticClass: "fontC" }, [
                            _vm._v("收货信息"),
                          ]),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-wrap": "wrap",
                              },
                            },
                            [
                              _vm.backInfo
                                ? _c(
                                    "div",
                                    { staticStyle: { color: "#4168e7" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.backInfo.logisticsCompanyLabel
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.backInfo
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "#4168e7",
                                        "margin-left": "10px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.backInfo.logisticsNumber) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-top": "10px" },
                              attrs: {
                                size: "small",
                                type: "primary",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.examine(2)
                                },
                              },
                            },
                            [_vm._v("查看物流")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.orderMessage.status == 5
                    ? _c("div", { staticStyle: { width: "300px" } }, [
                        _c("div", { staticClass: "fontC" }, [
                          _vm._v("出货信息"),
                        ]),
                        _c("div", { staticClass: "fontC" }, [
                          _vm._v("等待寄出换货"),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.orderMessage.status == 7
                    ? _c("div", { staticStyle: { width: "300px" } }, [
                        _c("div", { staticClass: "fontC" }, [
                          _vm._v("用户已手动取消售后申请！"),
                        ]),
                        _c("div", { staticClass: "fontC" }, [
                          _vm._v(
                            "时间: " + _vm._s(_vm.orderMessage.createdTime)
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.orderMessage.status == 8 &&
                  _vm.orderMessage.afterType == 0
                    ? _c("div", { staticStyle: { width: "300px" } }, [
                        _c("div", { staticClass: "fontC" }, [
                          _vm._v("退款金额已退回买家账户！"),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.orderMessage.status == 8 &&
                  _vm.orderMessage.afterType == 1
                    ? _c("div", { staticStyle: { width: "300px" } }, [
                        _c("div", { staticClass: "fontC" }, [
                          _vm._v(
                            "完成时间：" + _vm._s(_vm.orderMessage.completeTime)
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.orderMessage.status == 8 &&
                  _vm.orderMessage.afterType == 2
                    ? _c(
                        "div",
                        { staticStyle: { width: "300px" } },
                        [
                          _c("div", { staticClass: "fontC" }, [
                            _vm._v("买家成功签收，售后已完成！"),
                          ]),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-wrap": "wrap",
                              },
                            },
                            [
                              _vm.backInfo
                                ? _c(
                                    "div",
                                    { staticStyle: { color: "#4168e7" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.backInfo.logisticsCompanyLabel
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.backInfo
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "#4168e7",
                                        "margin-left": "10px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.backInfo.logisticsNumber) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-top": "10px" },
                              attrs: {
                                size: "small",
                                type: "primary",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.examine(2)
                                },
                              },
                            },
                            [_vm._v("查看物流")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _c("div", {
                staticStyle: {
                  width: "0px",
                  height: "124px",
                  border: "1px dashed #ebebfa",
                  opacity: "1",
                  "margin-left": "67px",
                  "margin-right": "41px",
                },
              }),
              _c(
                "div",
                { staticStyle: { width: "90%" } },
                [
                  _vm.orderMessage.afterType == 0
                    ? _c("Steps", { attrs: { stepInfo: _vm.statusNode } })
                    : _vm._e(),
                  _vm.orderMessage.afterType == 1
                    ? _c("Steps1", { attrs: { stepInfo: _vm.statusNode } })
                    : _vm._e(),
                  _vm.orderMessage.afterType == 2
                    ? _c("Steps2", { attrs: { stepInfo: _vm.statusNode } })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "contentDetails" }, [
        _c(
          "div",
          {
            staticClass: "title",
            staticStyle: { display: "flex", "align-items": "center" },
          },
          [_vm._v(" 订单信息 ")]
        ),
        _c("div", { staticClass: "order_details" }, [
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("订单编号"),
              ]),
              _vm.orderMessage.orderInfo
                ? _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.orderInfo.orderNo
                          ? _vm.orderMessage.orderInfo.orderNo
                          : "-"
                      )
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("订单类型"),
              ]),
              _vm.orderMessage.orderInfo
                ? _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.orderInfo.orderTypeLabel
                          ? _vm.orderMessage.orderInfo.orderTypeLabel
                          : "-"
                      )
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _vm._m(0),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("支付时间"),
              ]),
              _vm.orderMessage.orderInfo
                ? _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.orderInfo.payTime
                          ? _vm.orderMessage.orderInfo.payTime
                          : "-"
                      )
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _vm._m(1),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("备注信息"),
              ]),
              _vm.orderMessage.orderInfo
                ? _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(_vm._s(_vm.orderMessage.orderInfo.userRemark)),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _c("div", {
          staticStyle: {
            width: "100%",
            height: "0px",
            border: "1px dashed #ebebfa",
            opacity: "1",
            "margin-top": "14px",
          },
        }),
        _c(
          "div",
          { staticClass: "title", staticStyle: { "margin-top": "24px" } },
          [_vm._v("购买信息")]
        ),
        _c("div", { staticClass: "contentDetails_box" }, [
          _c(
            "div",
            {
              staticClass: "contentDetails_item",
              staticStyle: { display: "flex" },
            },
            [
              _c("div", { staticClass: "title_too" }, [_vm._v("收货信息")]),
              _c("div", { staticClass: "details" }, [
                _c("div", { staticClass: "details_item" }, [
                  _c(
                    "span",
                    {
                      staticClass: "details_title fourteen",
                      staticStyle: { "margin-left": "-24px" },
                    },
                    [_vm._v("收货人")]
                  ),
                  _vm.orderMessage.orderInfo
                    ? _c("span", { staticClass: "details_value fourteen" }, [
                        _vm._v(
                          _vm._s(
                            _vm.orderMessage.orderInfo.postName
                              ? _vm.orderMessage.orderInfo.postName
                              : "-"
                          )
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "details_item" }, [
                  _c("span", { staticClass: "details_title fourteen" }, [
                    _vm._v("联系方式"),
                  ]),
                  _vm.orderMessage.orderInfo
                    ? _c("span", { staticClass: "details_value fourteen" }, [
                        _vm._v(
                          _vm._s(
                            _vm.orderMessage.orderInfo.postPhone
                              ? _vm.orderMessage.orderInfo.postPhone
                              : "-"
                          )
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "details_item addressWidth" }, [
                  _c("span", { staticClass: "details_title fourteen" }, [
                    _vm._v("收货地址"),
                  ]),
                  _vm.orderMessage.orderInfo
                    ? _c("span", { staticClass: "details_value fourteen" }, [
                        _vm._v(
                          _vm._s(
                            _vm.orderMessage.orderInfo.postDistrictAddress
                          ) +
                            " " +
                            _vm._s(_vm.orderMessage.orderInfo.postAddress)
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "contentDetails_item",
              staticStyle: { display: "flex" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "title_too",
                  staticStyle: { "margin-left": "100px" },
                },
                [_vm._v("买家信息")]
              ),
              _c("div", { staticClass: "details" }, [
                _c("div", { staticClass: "details_item" }, [
                  _c(
                    "span",
                    {
                      staticClass: "details_title fourteen",
                      staticStyle: { "margin-left": "-10px" },
                    },
                    [_vm._v("客户姓名")]
                  ),
                  _vm.orderMessage.orderInfo
                    ? _c("span", { staticClass: "details_value fourteen" }, [
                        _vm._v(
                          _vm._s(
                            _vm.orderMessage.orderInfo.userName
                              ? _vm.orderMessage.orderInfo.userName
                              : "-"
                          )
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "details_item" }, [
                  _c("span", { staticClass: "details_title fourteen" }, [
                    _vm._v("客户电话"),
                  ]),
                  _vm.orderMessage.orderInfo
                    ? _c("span", { staticClass: "details_value fourteen" }, [
                        _vm._v(
                          _vm._s(
                            _vm.orderMessage.orderInfo.userPhone
                              ? _vm.orderMessage.orderInfo.userPhone
                              : "-"
                          )
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "contentDetails" },
        [
          _vm._m(2),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.orderAfterDetailList1,
                "header-cell-style": {
                  background: "#fafafa",
                  color: "#333333",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "updatedTime",
                  label: "商品信息",
                  headerAlign: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "left" } }, [
                          _c("div", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  props.row.goodsName
                                    ? props.row.goodsName
                                    : "-"
                                )
                              ),
                            ]),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                props.row.goodsSkuName
                                  ? props.row.goodsSkuName
                                  : "-"
                              )
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              " 商品编码：" +
                                _vm._s(
                                  props.row.goodsSkuNo
                                    ? props.row.goodsSkuNo
                                    : "-"
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "authListStr",
                  label: "单价/数量",
                  "header-align": "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "right" } }, [
                          _c("p", [
                            _vm._v(
                              " ￥" +
                                _vm._s(
                                  Number(props.row.retailPrice).toFixed(2) ||
                                    Number(props.row.unitPrice).toFixed(2)
                                ) +
                                " "
                            ),
                          ]),
                          _c("p", [
                            _vm._v("× " + _vm._s(props.row.afterQuantity)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "authListStr",
                  label: "运费",
                  "header-align": "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "right" } }, [
                          _c("p", [
                            _vm._v(
                              "￥" +
                                _vm._s(
                                  Number(props.row.freightAmount).toFixed(2)
                                )
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "authListStr",
                  label: "小计",
                  "header-align": "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "right" } }, [
                          _c("p", [
                            _vm._v(
                              "实付￥" +
                                _vm._s(Number(props.row.refundMoney).toFixed(2))
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("div", { staticClass: "fourteenDetails_title" }, [
            _vm._v("优惠信息"),
          ]),
          _vm.orderMessage.discountLabel
            ? _c("div", [
                _c("p", [_vm._v(_vm._s(_vm.orderMessage.discountLabel))]),
              ])
            : [
                _c(
                  "div",
                  {
                    staticClass: "fourteenDetails",
                    staticStyle: {
                      "margin-top": "12px",
                      "border-bottom": "1px solid #ededed",
                      "padding-bottom": "20px",
                    },
                  },
                  [_vm._v(" 无优惠 ")]
                ),
              ],
          _vm.orderMessage.afterType == 0 &&
          _vm.orderAfterDetailList2.length != 0
            ? _c("div", { staticClass: "titleBtn" }, [_vm._m(3)])
            : _vm._e(),
          _vm.orderMessage.afterType == 0 &&
          _vm.orderAfterDetailList2.length != 0
            ? _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.orderAfterDetailList2,
                    "header-cell-style": {
                      background: "#fafafa",
                      color: "#333333",
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "updatedTime",
                      label: "商品信息",
                      headerAlign: "left",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c("div", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          props.row.goodsName
                                            ? props.row.goodsName
                                            : "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        props.row.goodsSkuName
                                          ? props.row.goodsSkuName
                                          : "-"
                                      )
                                    ),
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      " 商品编码：" +
                                        _vm._s(
                                          props.row.goodsSkuNo
                                            ? props.row.goodsSkuNo
                                            : "-"
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1904138149
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "authListStr",
                      label: "单价/数量",
                      "header-align": "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c("p", [
                                    _vm._v(
                                      " ￥" +
                                        _vm._s(
                                          Number(props.row.retailPrice).toFixed(
                                            2
                                          ) ||
                                            Number(props.row.unitPrice).toFixed(
                                              2
                                            )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      "× " + _vm._s(props.row.afterQuantity)
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3717374410
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "authListStr",
                      label: "小计",
                      "header-align": "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "实付￥" +
                                        _vm._s(
                                          Number(props.row.refundMoney).toFixed(
                                            2
                                          )
                                        )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1069707495
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "total_prices" }, [
            _vm.orderMessage.orderInfo && _vm.orderMessage.afterType == 0
              ? _c(
                  "span",
                  { staticStyle: { color: "#666666", "margin-right": "15px" } },
                  [
                    _vm._v(
                      "商品总价：￥" +
                        _vm._s(
                          Number(
                            _vm.orderMessage.orderInfo.goodsAmount
                          ).toFixed(2) || "0.00"
                        )
                    ),
                  ]
                )
              : _vm._e(),
            (_vm.orderMessage.afterType == 1 ||
              _vm.orderMessage.afterType == 2) &&
            _vm.orderMessage.orderAfterDetailList
              ? _c(
                  "span",
                  { staticStyle: { color: "#666666", "margin-right": "15px" } },
                  [
                    _vm._v(
                      "商品总价：￥" +
                        _vm._s(
                          Number(
                            _vm.orderMessage.orderAfterDetailList[0]
                              .retailPrice *
                              _vm.orderMessage.orderAfterDetailList[0]
                                .afterQuantity
                          ).toFixed(2) || "0.00"
                        )
                    ),
                  ]
                )
              : _vm._e(),
            _vm.orderMessage.orderInfo && _vm.orderMessage.afterType == 0
              ? _c(
                  "span",
                  { staticStyle: { color: "#666666", "margin-right": "15px" } },
                  [
                    _vm._v(
                      "运费：￥" +
                        _vm._s(
                          Number(
                            _vm.orderMessage.orderInfo.freightAmount
                          ).toFixed(2) || "0.00"
                        )
                    ),
                  ]
                )
              : _vm._e(),
            (_vm.orderMessage.afterType == 1 ||
              _vm.orderMessage.afterType == 2) &&
            _vm.orderMessage.orderAfterDetailList
              ? _c(
                  "span",
                  { staticStyle: { color: "#666666", "margin-right": "15px" } },
                  [
                    _vm._v(
                      "运费：￥" +
                        _vm._s(
                          Number(
                            _vm.orderMessage.orderAfterDetailList[0]
                              .freightAmount
                          ).toFixed(2) || "0.00"
                        )
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "span",
              { staticStyle: { color: "red", "margin-right": "15px" } },
              [
                _vm._v(
                  "优惠：￥" +
                    _vm._s(
                      _vm.orderMessage.discountAmount
                        ? Number(_vm.orderMessage.discountAmount).toFixed(2)
                        : "0.00"
                    )
                ),
              ]
            ),
            _vm.orderMessage.afterType == 0
              ? _c(
                  "span",
                  { staticStyle: { color: "#444", "margin-right": "15px" } },
                  [
                    _vm._v(
                      "应付：￥" +
                        _vm._s(Number(_vm.orderMessage.refundMoney).toFixed(2))
                    ),
                  ]
                )
              : _vm._e(),
            (_vm.orderMessage.afterType == 1 ||
              _vm.orderMessage.afterType == 2) &&
            _vm.orderMessage.orderAfterDetailList
              ? _c(
                  "span",
                  { staticStyle: { color: "#444", "margin-right": "15px" } },
                  [
                    _vm._v(
                      "应付：￥" +
                        _vm._s(
                          Number(
                            _vm.orderMessage.orderAfterDetailList[0]
                              .refundMoney +
                              _vm.orderMessage.orderAfterDetailList[0]
                                .freightAmount
                          ).toFixed(2)
                        )
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "span",
              { staticStyle: { color: "#6190ed", "margin-right": "15px" } },
              [
                _vm._v(
                  "（实付：￥" +
                    _vm._s(Number(_vm.orderMessage.refundMoney).toFixed(2)) +
                    "）"
                ),
              ]
            ),
            _vm.orderMessage.afterType == 0 || _vm.orderMessage.afterType == 1
              ? _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(
                    "应退款金额：￥" +
                      _vm._s(Number(_vm.orderMessage.refundMoney).toFixed(2))
                  ),
                ])
              : _vm._e(),
          ]),
          _c("div", {
            staticStyle: {
              border: "1px dashed #ebebfa",
              "margin-top": "25px",
              "margin-bottom": "24px",
            },
          }),
          _c("div", [
            _c("label", { staticClass: "afterTitle" }, [_vm._v("售后信息")]),
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                [
                  _c(
                    "el-form",
                    { attrs: { inline: true, "label-position": "left" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: "售后编号" },
                        },
                        [
                          _c("div", { staticClass: "afterInfo" }, [
                            _vm._v(_vm._s(_vm.orderMessage.afterNo)),
                          ]),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: "售后类型" },
                        },
                        [
                          _c("div", { staticClass: "afterInfo" }, [
                            _vm._v(_vm._s(_vm.orderMessage.afterTypeLabel)),
                          ]),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: "售后原因" },
                        },
                        [
                          _c("div", { staticClass: "afterInfo" }, [
                            _vm._v(_vm._s(_vm.orderMessage.afterReasonLabel)),
                          ]),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: "售后说明" },
                        },
                        [
                          _c("div", { staticClass: "afterInfo" }, [
                            _vm._v(_vm._s(_vm.orderMessage.afterRemark)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-form",
                    { attrs: { inline: true } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "售后图片" } },
                        _vm._l(_vm.imgs, function (item, index) {
                          return _c("el-image", {
                            key: index,
                            staticStyle: {
                              width: "118px",
                              height: "118px",
                              "border-radius": "3px",
                              "margin-top": "8px",
                              "margin-left": "10px",
                              cursor: "pointer",
                            },
                            attrs: { src: item, lazy: "" },
                            on: {
                              click: function ($event) {
                                return _vm.look(item)
                              },
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm.orderMessage.afterType != 2
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      float: "right",
                      "font-size": "16px",
                      "font-family": "Microsoft YaHei",
                      "font-weight": "bold",
                      color: "#f63c56",
                    },
                  },
                  [
                    _vm.orderMessage.status == 1 ||
                    _vm.orderMessage.status == 2 ||
                    _vm.orderMessage.status == 7 ||
                    _vm.orderMessage.status == 3 ||
                    _vm.orderMessage.status == 4 ||
                    _vm.orderMessage.status == 5
                      ? _c("div", [_vm._v(" 已退款金额：￥0.00 ")])
                      : _c("div", [
                          _vm._v(
                            " 已退款金额：￥" +
                              _vm._s(
                                _vm.orderMessage.refundMoney
                                  ? Number(
                                      _vm.orderMessage.refundMoney
                                    ).toFixed(2)
                                  : "0"
                              ) +
                              " "
                          ),
                        ]),
                  ]
                )
              : _vm._e(),
            _vm.orderMessage.afterType !== 0 && _vm.orderMessage.status != 1
              ? _c("div", {
                  staticStyle: {
                    border: "1px dashed #ebebfa",
                    "margin-top": "44px",
                    "margin-bottom": "24px",
                  },
                })
              : _c("div", { staticStyle: { "margin-top": "24px" } }),
            _vm.orderMessage.afterType !== 0 && _vm.orderMessage.status != 1
              ? _c(
                  "label",
                  {
                    staticClass: "afterTitle",
                    staticStyle: { "margin-top": "24px" },
                  },
                  [_vm._v("寄回信息")]
                )
              : _vm._e(),
            _vm.orderMessage.afterType !== 0 && _vm.orderMessage.status != 1
              ? _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            inline: true,
                            "label-position": "right",
                            "label-width": "86px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { label: "退回地址" },
                            },
                            [
                              _vm.backInfo1
                                ? _c("span", { staticClass: "afterInfo" }, [
                                    _vm._v(_vm._s(_vm.backInfo1.postAddress)),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { label: "退货电话" },
                            },
                            [
                              _vm.backInfo1
                                ? _c("span", { staticClass: "afterInfo" }, [
                                    _vm._v(_vm._s(_vm.backInfo1.postContact)),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { label: "退货联系人" },
                            },
                            [
                              _vm.backInfo1
                                ? _c("span", { staticClass: "afterInfo" }, [
                                    _vm._v(_vm._s(_vm.backInfo1.postName)),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "botton_btn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "info" },
              on: {
                click: function ($event) {
                  return _vm.back()
                },
              },
            },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type == "logisticsInformation"
            ? [
                _c("StepLogistics", {
                  attrs: { stepProgress: _vm.logisticsNode },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type == "shipmentsCode"
            ? [
                _c(
                  "el-form",
                  {
                    ref: "wuliu",
                    attrs: {
                      model: _vm.wuliu,
                      rules: _vm.wuliuRules,
                      "label-width": "80px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "出库仓库",
                          "label-width": "100px",
                          prop: "warehouse",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              filterable: "",
                              placeholder: "请选择出库仓库",
                            },
                            model: {
                              value: _vm.wuliu.warehouse,
                              callback: function ($$v) {
                                _vm.$set(_vm.wuliu, "warehouse", $$v)
                              },
                              expression: "wuliu.warehouse",
                            },
                          },
                          _vm._l(_vm.commWarehouseList, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "物流公司",
                          "label-width": "100px",
                          prop: "company",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              filterable: "",
                              placeholder: "请选择物流公司",
                            },
                            model: {
                              value: _vm.wuliu.company,
                              callback: function ($$v) {
                                _vm.$set(_vm.wuliu, "company", $$v)
                              },
                              expression: "wuliu.company",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.courier_company,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.dictName,
                                  value: item.dictId,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "物流单号",
                          "label-width": "100px",
                          prop: "odd",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            oninput: "value=value.replace(/[^\\w_]/g,'')",
                          },
                          model: {
                            value: _vm.wuliu.odd,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.wuliu,
                                "odd",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "wuliu.odd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "dialogBtn" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.dialog.visible = false
                              },
                            },
                          },
                          [_vm._v("取 消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.dialogSubmitwuliu("wuliu")
                              },
                            },
                          },
                          [_vm._v("确 定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "addAddress"
            ? [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      rules: _vm.rules,
                      "label-width": "80px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "收货人姓名",
                          "label-width": "100px",
                          prop: "userName",
                        },
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.userName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "userName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.userName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "联系电话",
                          "label-width": "100px",
                          prop: "phone",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            oninput: "value=value.replace(/[^0-9.]/g,'')",
                            maxLength: 11,
                          },
                          model: {
                            value: _vm.form.phone,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "phone",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.phone",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "收货地址",
                          "label-width": "100px",
                          prop: "addressValue",
                        },
                      },
                      [
                        _c("el-cascader", {
                          attrs: {
                            options: _vm.addressOptions,
                            clearable: "",
                            filterable: "",
                          },
                          on: { change: _vm.onChangeAddress },
                          model: {
                            value: _vm.form.addressValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "addressValue", $$v)
                            },
                            expression: "form.addressValue",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "详细地址",
                          "label-width": "100px",
                          prop: "detailedAddress",
                        },
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.detailedAddress,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "detailedAddress",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.detailedAddress",
                          },
                        }),
                        _c(
                          "el-checkbox",
                          {
                            attrs: { "false-label": 0, "true-label": 1 },
                            model: {
                              value: _vm.form.isDefault,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "isDefault", $$v)
                              },
                              expression: "form.isDefault",
                            },
                          },
                          [_vm._v("设为默认 ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "dialogBtn" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.dialog.visible = false
                              },
                            },
                          },
                          [_vm._v("取 消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.dialogSubmit("form")
                              },
                            },
                          },
                          [_vm._v("确 定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "addRemark"
            ? [
                _c(
                  "el-form",
                  { attrs: { "label-width": "50px" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "备注" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 5,
                            placeholder: "请输入备注",
                          },
                          model: {
                            value: _vm.remark,
                            callback: function ($$v) {
                              _vm.remark = $$v
                            },
                            expression: "remark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "dialogBtn" },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.dialog.visible = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmAddRemark },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "addressAmend"
            ? [
                _c(
                  "span",
                  { staticClass: "addressHeader" },
                  [
                    _c("i", {
                      staticClass: "el-icon-circle-plus-outline",
                      staticStyle: { color: "#4168e7" },
                    }),
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#4168e7" },
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.addAddress("Address")
                          },
                        },
                      },
                      [_vm._v("新增收货地址")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.siteDataList,
                      "header-cell-style": {
                        background: "#F8F8F9",
                        color: "#333333",
                      },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "收货人", prop: "userName" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "手机号码", prop: "phone" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "地区", prop: "userName" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        props.row.provinceCode
                                          ? props.row.provinceCode +
                                              props.row.cityCode +
                                              props.row.regionCode
                                          : "-"
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        197606537
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "详细地址", prop: "detailedAddress" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "默认地址" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": 1,
                                    "inactive-value": 0,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.defaultSite(props.row.id)
                                    },
                                  },
                                  model: {
                                    value: props.row.isDefault,
                                    callback: function ($$v) {
                                      _vm.$set(props.row, "isDefault", $$v)
                                    },
                                    expression: "props.row.isDefault",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        234956708
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.employ(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v("使用 ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.dialogEdit(
                                          "editAddress",
                                          props.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("编辑 ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "red" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.dialogDelete(props.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("删除 ")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1854051084
                      ),
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogToo.title,
            visible: _vm.dialogToo.visible,
            width: _vm.dialogToo.width,
            "append-to-body": "",
            "before-close": _vm.handleCloseToo,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialogToo, "visible", $event)
            },
          },
        },
        [
          _vm.dialogToo.type == "selectPay"
            ? [
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.selectPayment },
                    model: {
                      value: _vm.setPay.payment,
                      callback: function ($$v) {
                        _vm.$set(_vm.setPay, "payment", $$v)
                      },
                      expression: "setPay.payment",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "1" } }, [
                      _vm._v("在线支付"),
                    ]),
                  ],
                  1
                ),
                _c("div", { staticClass: "setPayDialogBtn" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          on: { change: _vm.selectPayDefault },
                          model: {
                            value: _vm.setPay.payDefault,
                            callback: function ($$v) {
                              _vm.$set(_vm.setPay, "payDefault", $$v)
                            },
                            expression: "setPay.payDefault",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            { attrs: { label: "1", name: "type" } },
                            [_vm._v("设为默认")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_quxiao",
                          on: { click: _vm.handleCloseToo },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_queren",
                          attrs: { type: "primary" },
                          on: { click: _vm.confirmSelectPay },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _vm.dialogToo.type == "payMoney"
            ? [
                _c("div", { staticClass: "payMoney" }, [
                  _c("div", [
                    _c("p", { staticClass: "payMoney_should" }, [
                      _vm._v(
                        " 应付:￥" +
                          _vm._s(_vm.orderMessage.receivableAmount) +
                          " "
                      ),
                    ]),
                    _c("p", { staticClass: "payMoney_already" }, [
                      _vm._v("已收:￥200.00"),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "payMoney_box" },
                    [
                      _c("span", { staticClass: "payMoney_money" }, [
                        _vm._v("支付金额"),
                      ]),
                      _c("span", { staticClass: "payMoney_mo" }, [
                        _vm._v("￥"),
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "110px" },
                        attrs: {
                          controls: false,
                          mix: 0,
                          type: "number",
                          precision: 2,
                        },
                        model: {
                          value: _vm.paymentAmount,
                          callback: function ($$v) {
                            _vm.paymentAmount = $$v
                          },
                          expression: "paymentAmount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "payMoney_text" }, [
                    _c("span", { staticClass: "payMoney_text_item" }, [
                      _vm._v("总计: 共" + _vm._s(_vm.totalQuantity) + "件"),
                    ]),
                    _c("span", { staticClass: "payMoney_text_item" }, [
                      _vm._v("商品总价: ￥" + _vm._s(_vm.totalPrices)),
                    ]),
                    _c("span", { staticClass: "payMoney_text_item" }, [
                      _vm._v(
                        "运费: ￥" + _vm._s(_vm.orderMessage.freightAmount)
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "dialogBtnright" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_quxiao",
                          on: { click: _vm.handleCloseToo },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_queren",
                          attrs: { type: "primary" },
                          on: { click: _vm.onlinePayment },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _vm.dialogToo.type == "closeOrder"
            ? [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.setCloseOrder,
                      callback: function ($$v) {
                        _vm.setCloseOrder = $$v
                      },
                      expression: "setCloseOrder",
                    },
                  },
                  _vm._l(
                    _vm.dictionaries.order_main_close_reason,
                    function (item, index) {
                      return _c(
                        "el-radio",
                        {
                          key: index,
                          staticClass: "setPay_payment",
                          attrs: { label: item.dictId },
                        },
                        [_vm._v(_vm._s(item.dictName))]
                      )
                    }
                  ),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: { click: _vm.handleCloseToo },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.handlerCloseOrderSubmit },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialogToo.type == "audit"
            ? [
                _c("div", { staticClass: "audit_title" }, [
                  _vm._v("是否审核通过？"),
                ]),
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.handlerSelect },
                    model: {
                      value: _vm.selectShenhe,
                      callback: function ($$v) {
                        _vm.selectShenhe = $$v
                      },
                      expression: "selectShenhe",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "2" } }, [_vm._v("通过")]),
                    _c("el-radio", { attrs: { label: "3" } }, [
                      _vm._v("不通过"),
                    ]),
                  ],
                  1
                ),
                _vm.selectShenhe == 3
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "audit_textarea",
                            attrs: { "label-width": "40px" },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "原因" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入原因",
                                    maxlength: "200",
                                    "show-word-limit": "",
                                    type: "textarea",
                                  },
                                  model: {
                                    value: _vm.cause,
                                    callback: function ($$v) {
                                      _vm.cause = $$v
                                    },
                                    expression: "cause",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: { click: _vm.handleCloseToo },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.handlerAuditsubmit },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "售后申请",
            visible: _vm.isApply,
            width: "518px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isApply = $event
            },
          },
        },
        [
          [
            _c("div", { staticClass: "info" }, [_vm._v("是否审核通过？")]),
            _c(
              "div",
              { staticStyle: { "margin-top": "18px" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.status,
                      callback: function ($$v) {
                        _vm.status = $$v
                      },
                      expression: "status",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("通过")]),
                    _c("el-radio", { attrs: { label: 2 } }, [_vm._v("驳回")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.status == 1
              ? _c("div", { staticClass: "pass" }, [
                  _vm._v(" 确认后，金额"),
                  _c("span", { staticStyle: { color: "#f63c56" } }, [
                    _vm._v("￥" + _vm._s(_vm.orderMessage.refundMoney)),
                  ]),
                  _vm._v("将退回买家账户 "),
                ])
              : _vm._e(),
            _vm.status == 2
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "24px",
                      width: "90%",
                      "margin-bottom": "24px",
                    },
                  },
                  [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-right": "8px", width: "10%" },
                        },
                        [_vm._v("备注")]
                      ),
                      _c(
                        "div",
                        { staticStyle: { width: "90%" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入备注",
                              maxlength: "200",
                              "show-word-limit": "",
                              rows: "5",
                            },
                            model: {
                              value: _vm.remark,
                              callback: function ($$v) {
                                _vm.remark = $$v
                              },
                              expression: "remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isApply = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-s",
                    on: {
                      click: function ($event) {
                        return _vm.submitApply()
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: {
              width: "100%",
              fit: "contain",
              src: _vm.dialogImageUrl,
              alt: "",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "order_details_box" }, [
      _c("div", { staticClass: "order_details_item" }, [
        _c("span", { staticClass: "order_details_title" }, [
          _vm._v("支付方式"),
        ]),
        _c("span", { staticClass: "order_details_value" }, [
          _vm._v("在线支付"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "order_details_box" }, [
      _c("div", { staticClass: "order_details_item" }, [
        _c("span", { staticClass: "order_details_title" }, [
          _vm._v("订单分类"),
        ]),
        _c("span", { staticClass: "order_details_value" }, [_vm._v("自动单")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "titleBtn" }, [
      _c(
        "div",
        { staticClass: "title", staticStyle: { "margin-bottom": "20px" } },
        [_c("label", [_vm._v("商品信息")])]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "title",
        staticStyle: { "margin-top": "20px", "margin-bottom": "20px" },
      },
      [_c("label", [_vm._v("赠品商品")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }